import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for /setup/business-units/* — the list and a unit's own page nest
// under it. No shared chrome.
export const Route = createFileRoute('/_authenticated/setup/business-units')({
  component: () => <Outlet />,
});
